import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space, Card, Select, Row, Col, Radio } from 'antd';
import ProductService from "services/product";
import ProductTagService from "services/product_tag";
import ProductCategoryService from "services/product_category";
import ImagePicker from "components/pickers/image/ImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import Block from "./Block"
import _ from "lodash"
const service = new ProductService();
const ProductsPicker = ({ value = { method: "list", list: [], tag: [], category: [] }, onChange }) => {
    console.log("value product picker", value)
    const [products, setProducts] = useState([]);
    const [tags, setTags] = useState([]);
    const [category, setCategory] = useState([]);
    const [filter, setFilter] = useState(value)
    useEffect(() => {
        loadData();
    }, [])


    useEffect(() => {

        if (!value) {
            setFilter({ method: "list", list: [], })
            return;
        }

        if (!_.isEqual(value, filter)) {

            setFilter(value);
        }

    }, [value])


    useEffect(() => {

        if (!_.isEqual(value, filter)) {
            onChange(filter)
        }

    }, [filter])





    const loadData = async () => {
        var lst = await service.list();
        lst = lst.map(x => {
            return { label: x.name, value: x.id }
        })
        setProducts(lst)

        const tagServices = new ProductTagService();
        var lstTag = await tagServices.list()
        lstTag = lstTag.map(x => {
            return { label: x.name, value: x.id }
        })
        setTags(lstTag)


        const categoryService = new ProductCategoryService();
        var lstTag = await categoryService.list()
        lstTag = lstTag.map(x => {
            return { label: x.name, value: x.id }
        })
        setCategory(lstTag)
    }

    const onMethodChange = (a) => {
        setFilter({ ...filter, method: a.target.value })
    }

    const onListChange = (a) => {
        setFilter({ ...filter, list: a })
    }

    const onTagChange = (a) => {
        setFilter({ ...filter, tag: a })
    }
    const onCategoryChange = (a) => {
        setFilter({ ...filter, category: a })
    }










    return (
        <Space direction='vertical' style={{ width: "100%" }}>
            <Radio.Group
                value={filter.method}
                onChange={onMethodChange}
                options={[
                    { value: 'list', label: 'Danh sách' },
                    { value: 'tag', label: 'Nhãn' },
                    { value: 'category', label: 'Phân loại' },
                    { value: 'all', label: 'Tất cả' },
                ]}
            />
            {filter.method == "list" &&

                <Select value={filter.list} mode='multiple' options={products} onChange={onListChange} ></Select>
            }

            {filter.method == "tag" &&

                <Select value={filter.tag} mode='multiple' options={tags} onChange={onTagChange} ></Select>
            }

            {filter.method == "category" &&

                <Select value={filter.category} mode='multiple' options={category} onChange={onCategoryChange} ></Select>
            }

        </Space>
    )
}
export default ProductsPicker;